function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.333,
    height: 16,
    viewBox: "0 0 21.333 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11087",
    d: "M25.476 5v2.286h-6.1V21H17.1V7.286H11V5z",
    transform: "translate(-4.143 -5)",
    style: {
      fill: "#252529"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11088",
    d: "M5.81 22.667v-9.143H2V12h9.143v1.524h-3.81v9.143z",
    transform: "translate(-2 -6.667)",
    style: {
      fill: "#252529"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTTextIcon);
export default __webpack_public_path__ + "static/media/tTextIcon.ac50ad7bae8206a0a9deac0686e7dad3.svg";
export { ForwardRef as ReactComponent };